module.exports = __webpack_public_path__ + "img/primary_9x3_z16.8cf69675.svg";